import { clearCsrfToken } from '../common/utils/auth/csrf'

// Clear all frontend session state, including CSRF state tied to the current cookie session.
export const clearPortalSessionClientState = (): void => {
    clearCsrfToken()
}
